import { TEXT_VARIANTS } from '@pukka/common/constants';
import { twMerge } from 'tailwind-merge';

import { Icon } from '../../Icon';
import { Text } from '../../Text';

import { SIZES } from './state';
import { SelectOptionProps, SelectValue } from './types';
import { getValueAsTextFrom } from './utils';

function SelectOption<T extends SelectValue>(props: SelectOptionProps<T, true>) {
  const { type, size = 'm' } = props;
  const sizing = SIZES[size];

  if (type === 'group') {
    const { value, children, className } = props;

    return (
      <Text variant={sizing.variant} color="primary" weight="semibold" className={twMerge(sizing.option.group, className)}>
        {children ?? value}
      </Text>
    );
  }

  const { value, disabled, selected, children, className, icon, ...rest } = props;

  return (
    <div
      {...(rest as Omit<typeof rest, 'key'>)}
      className={twMerge(
        'flex flex-row items-center',
        'rounded-md',
        'text-secondary',
        'fill-primary',
        TEXT_VARIANTS[sizing.variant].size,
        sizing.option.content,
        !disabled && 'hover:bg-light-blue-50 focus:bg-light-blue-50 group-radix-highlighted:bg-light-blue-50',
        'transition duration-300',
        className,
      )}
    >
      {icon ? <Icon icon={icon} size={sizing.icon} /> : null}
      {children ?? getValueAsTextFrom(value)}
      {selected ? <Icon icon="checkmark" size={sizing.icon} className="ml-auto" /> : null}
    </div>
  );
}

export { SelectOption };
